import { Link } from 'react-router-dom';
import { siteName, siteSlogan } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">{siteName}</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
            {siteSlogan}。面向剧情党的火影同人RPG游戏攻略站，帮你解锁隐藏剧情与每一个结局。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">站点导航</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/">首页</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/games">游戏库</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/endings">结局攻略</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/about">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold text-foreground-950">攻略主题</h3>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/games">剧情向角色扮演</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/endings">多结局走向</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/games">隐藏剧情触发</Link></li>
            <li><Link className="text-foreground-600 hover:text-primary-600" to="/about">关于火影同人</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-5 sm:flex-row md:px-6">
          <p className="font-label text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteName} · 剧情党专属攻略站
          </p>
          <p className="font-label text-xs text-foreground-500">
            联系邮箱：<a href="mailto:contact@example.com" className="hover:text-primary-600">contact@example.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
}